export default __webpack_public_path__ + "static/card-product-redime-2-34a9ee2daa7c5d34343d28edcc2b1033.png";